export default class Accordion {


	// Constructor
	constructor(element, titleSelector, buttonSelector, panelSelector, closedHeightRefSelector) {

		this.element = element;
		this.title = this.element.querySelector(titleSelector)
		this.button = this.element.querySelector(buttonSelector);
		this.panel = this.element.querySelector(panelSelector);
		this.closedHeightRefElem = this.element.querySelector(closedHeightRefSelector)

		this.buttonClick = this.buttonClick.bind(this);
		this.resize = this.resize.bind(this);

		if (!this.panel.id) {
			this.panel.id = 'accordion-' + Math.floor(Math.random() * 1000);
		}

	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.element;
		delete this.button;
		delete this.panel;
	}
	enable() {
		this.disable();
		this.button.addEventListener('click', this.buttonClick);
		this.button.setAttribute('aria-controls', this.panel.id);
		if (this.element.classList.contains('opened')) {
			this.button.setAttribute('aria-expanded', 'true');
			this.panel.setAttribute('aria-hidden', 'false');
		} else {
			this.button.setAttribute('aria-expanded', 'false');
			this.panel.setAttribute('aria-hidden', 'true');
		}

		window.addEventListener('resize', this.resize)

		this.setDimensions()
	}

	setDimensions() {
		let refRect = this.closedHeightRefElem.getBoundingClientRect()
		this.title.style.height = `${refRect.height}px`
	}

	resize() {
		setTimeout(() => {
			this.setDimensions()
		})
	}

	disable() {
		this.button.removeEventListener('click', this.buttonClick);
		window.removeEventListener('resize', this.resize)
		this.button.removeAttribute('aria-controls');
		this.button.removeAttribute('aria-expanded');
		this.panel.removeAttribute('aria-hidden');
	}


	// Private Methods
	open() {
		this.element.classList.add('opened');
		this.button.setAttribute('aria-expanded', 'true');
		this.panel.setAttribute('aria-hidden', 'false');
	}
	close() {
		this.element.classList.remove('opened');
		this.button.setAttribute('aria-expanded', 'false');
		this.panel.setAttribute('aria-hidden', 'true');
	}


	// Event Handlers
	buttonClick(event) {
		event.preventDefault();
		if (this.element.classList.contains('opened')) {
			this.close();
		} else {
			this.open();
		}
	}

}
